import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from '@angular/fire/compat/firestore';
import { Observable, of } from 'rxjs';
import { catchError, first, map, switchMap, tap } from 'rxjs/operators';
import * as XLSX from 'xlsx';

interface PromedioDimension {
  Adaptabilidad: number[];
  Agilidad: number[];
  Conocimiento: number[];
  Digital: number[];
  Flexibilidad: number[];
  MtzGeneralDim: number[];
}

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  code = 'xbZJt5LRIoPH4hGgvbCMxaeg2zn1';
  exist = false;
  infoSapiolab = {
    coleccion: 'pruebasCSE',
    uidDoc: '',
    tipo: '',
  };
  constructor(public db: AngularFirestore) {}

  verifyCode(query: any) {
    if (query['e']) {
      this.infoSapiolab.tipo = 'empresas';
      this.infoSapiolab.uidDoc = query['e'];
      sessionStorage.setItem('infoSapiolab', JSON.stringify(this.infoSapiolab));
      return true;
    } else {
      alert('Enlace incorrecto');
      return false;
    }
  }

  async checkAvailableTest() {
    const docRef = this.db
      .collection(this.infoSapiolab.tipo)
      .doc(this.infoSapiolab.uidDoc);
    const docSnap = await docRef.get().toPromise();

    if (docSnap.exists) {
      const data = docSnap.data() as { pruebasCSE?: { disponibles: number } };
      if (data.pruebasCSE && data.pruebasCSE.disponibles > 0) {
        sessionStorage.setItem(
          'infoSapiolab',
          JSON.stringify(this.infoSapiolab)
        );
        return true;
      } else {
        console.warn('⚠️ No hay pruebas disponibles.');
        return false;
      }
    } else {
      alert('El enlace es incorrecto o no existe.');
      return false;
    }
  }

  getUserByCedula(cc: any): Observable<any[]> {
    const coleccion = this.infoSapiolab.coleccion;
    const ccString = cc.toString();
    const ccNumber = Number(cc);

    return this.db
      .collection(coleccion, (ref) => ref.where('Cedula', '==', ccString))
      .valueChanges({ idField: 'id' })
      .pipe(
        first(),
        switchMap((data: any[]) => {
          if (data.length > 0) {
            return of(data);
          } else {
            return this.db
              .collection(coleccion, (ref) =>
                ref.where('Cedula', '==', ccNumber)
              )
              .valueChanges({ idField: 'id' })
              .pipe(first());
          }
        }),
        catchError((err) => {
          console.error('🚨 Error al buscar usuario:', err);
          return of([]);
        })
      );
  }

  getUserByUID(uid: string): Observable<any | null> {
    return this.db
      .collection('pruebasCSE')
      .doc(uid)
      .valueChanges({ idField: 'id' }) 
      .pipe(
        first(),
        catchError(err => {
          console.error('❌ Error buscando documento por ID:', err);
          return of(null);
        })
      );
  }

  updateDatos(datos: object) {
    const info = JSON.parse(sessionStorage.getItem('infoSapiolab'));
    if (!info?.uidDoc) {
      console.warn(
        '⚠️ UID no disponible, no se guardará correctamente en Firestore'
      );
    }
    const datosConUid = {
      ...datos,
      uid: info?.uidDoc,
    };

    return this.db
      .collection('pruebasCSE')
      .add(datosConUid)
      .then(async (docRef) => {
        const docSnap = await docRef.get();
        const data = docSnap.data() as { uid: string };
        sessionStorage.setItem('id', docRef.id);
      });
  }

  updateResultados(
    dimension: object,
    dominio: object,
    radardimension: object,
    radardominio: object,
    respuestasdimension: object
  ) {
    const dbRef = this.db
      .collection('pruebasCSE')
      .doc(sessionStorage.getItem('id'));
    dbRef.get().subscribe((res) => {
      var data = res.data();
      dbRef
        .update({
          ['PromedioDimension']: dimension,
          ['PromedioDominio']: dominio,
          ['RadarDimension']: radardimension,
          ['RadarDominio']: radardominio,
          ['RespuestasDimension']: respuestasdimension,
        })
        .then(() => {
          const info = JSON.parse(sessionStorage.getItem('infoSapiolab'));
          const docRefEmpresa = this.db.collection(info.tipo).doc(info.uidDoc);

          docRefEmpresa.get().subscribe((docSnap) => {
            const data = docSnap.data() as any;
            if (data?.pruebasCSE?.disponibles > 0) {
              docRefEmpresa.update({
                'pruebasCSE.disponibles': data.pruebasCSE.disponibles - 1,
                'pruebasCSE.total': data.pruebasCSE.total - 1,
              });
            } else {
              console.warn('⚠️ No hay pruebas disponibles para descontar');
            }
          });
        });
    });
  }

  downloadXML() {
    let dataSearch = [];
    this.db
      .collection('pruebasCSE')
      .valueChanges()
      .subscribe((data: Array<any>) => {
        data.forEach((resultados, index) => {
          if (resultados.PromedioDimension != '') {
            let colaborador = {
              fecha: resultados.fecha || '',
              Cedula: resultados.Cedula,
              Nombres: resultados.Nombres,
              Apellidos: resultados.Apellidos,
              Correo: resultados.Correo,
              Cargo: resultados.Cargo,
              Area: resultados.Area || '',
              Descripcion: resultados.Descripcion,
              Edad: resultados.Edad,
              Empresa: resultados.Empresa,
              Genero: resultados.Genero,
              Nivel_cargo: resultados.Nivel_cargo,
              Años_cargo: resultados.Actual_cargo || '',

              PromedioAdaptabilidad:
                resultados.PromedioDominio.PromedioAdaptabilidad,
              PromedioAgilidad: resultados.PromedioDominio.PromedioAgilidad,
              PromedioConocimiento:
                resultados.PromedioDominio.PromedioConocimiento,
              PromedioDigital: resultados.PromedioDominio.PromedioDigital,
              PromedioFlexibilidad:
                resultados.PromedioDominio.PromedioFlexiblidad,

              RadarAdaptabilidad: resultados.RadarDominio.radarAdaptabilidad,
              RadarAgilidad: resultados.RadarDominio.radarAgilidad,
              RadarConocimiento: resultados.RadarDominio.radarConocimiento,
              RadarDigital: resultados.RadarDominio.radarDigital,
              RadarFlexibilidad: resultados.RadarDominio.radarFlexiblidad,

              PromedioAsignacion: resultados.PromedioDimension.Agilidad[1],
              PromedioClientes: resultados.PromedioDimension.Conocimiento[2],
              PromedioCompetencia: resultados.PromedioDimension.Conocimiento[1],
              PromedioCultura: resultados.PromedioDimension.Digital[1],
              PromedioDeterminacion: resultados.PromedioDimension.Agilidad[0],
              PromedioEjecucion: resultados.PromedioDimension.Agilidad[2],
              PromedioEstrategia: resultados.PromedioDimension.Digital[0],
              PromedioExperimentacion:
                resultados.PromedioDimension.Flexibilidad[2],
              PromedioGerencia: resultados.PromedioDimension.Flexibilidad[1],
              PromedioLiderzago: resultados.PromedioDimension.Flexibilidad[0],
              PromedioOrganigrama:
                resultados.PromedioDimension.Adaptabilidad[1],
              PromedioProcesos: resultados.PromedioDimension.Adaptabilidad[0],
              PromedioProductivo: resultados.PromedioDimension.Adaptabilidad[2],
              PromedioTalentos: resultados.PromedioDimension.Digital[2],
              PromedioTendencias: resultados.PromedioDimension.Conocimiento[0],

              RadarAsignacion: resultados.RadarDimension.radarAsignacion,
              RadarClientes: resultados.RadarDimension.radarClientes,
              RadarCompetencia: resultados.RadarDimension.radarCompetencia,
              RadarCultura: resultados.RadarDimension.radarCultura,
              RadarDeterminacion: resultados.RadarDimension.radarDeterminacion,
              RadarEjecucion: resultados.RadarDimension.radarEjecucion,
              RadarEstrategia: resultados.RadarDimension.radarEstrategia,
              RadarExperimentacion:
                resultados.RadarDimension.radarExperimentacion,
              RadarGerencia: resultados.RadarDimension.radarGerencia,
              RadarLiderzago: resultados.RadarDimension.radarLiderzago,
              RadarOrganigrama: resultados.RadarDimension.radarOrganigrama,
              RadarProcesos: resultados.RadarDimension.radarProcesos,
              RadarProductivo: resultados.RadarDimension.radarProductivo,
              RadarTalentos: resultados.RadarDimension.radarTalentos,
              RadarTendencias: resultados.RadarDimension.radarTendencias,

              Sector: resultados.Sector,
            };
            dataSearch.push(colaborador);
          }

          if (index == data.length - 1) {
            const fileName = 'Reporte de pruebas CSE.xlsx';

            const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataSearch);
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');

            XLSX.writeFile(wb, fileName);
          }
        });
      });

    // .then((querySnapshot) => {
    //   querySnapshot.forEach((doc) => {
    //     console.log(doc.data());
    //
    //   });
    // })
    // .catch((error) => {
    //   console.log(error);
    // });
  }
}
